export const emptyStringToNull = (v: string): string | null => !!v ? v : null;
